import { useEffect, useState } from "react";
import client from "@/lib/api";

let cache = null;
const listeners = new Set();

export async function reloadOrgClassifications() {
  const { data } = await client.get("/org-classifications");
  cache = data;
  listeners.forEach((fn) => fn(data));
  return data;
}

export function useOrgClassifications() {
  const [v, setV] = useState(cache || { tiers: [], markets: [] });
  useEffect(() => {
    listeners.add(setV);
    if (!cache) reloadOrgClassifications().catch(() => {});
    return () => listeners.delete(setV);
  }, []);
  return v;
}
